export default __webpack_public_path__ + "static/media/Wolf's Armbands of World's Edge.296b1e8b.jpg";